<template>
  <div class="layout-pay">
    <topBar></topBar>
    <div class="head">
      <div class="head main">
        <div class="head-top">
          <router-link tag="div" to="/" class="logo-img">
            <img src="../assets/imgs/logo.png" width="200" />
          </router-link>
          <div class="search-box">
            <!-- <input class="search-input" placeholder="请输入商品名称/商品链接" />
            <span class="search-btn">
              <i class="iconfont icon-search mr10"></i>搜索
            </span> -->
            <a-input-search style="width: 400px;" placeholder="请输入商品名称" @search="onSearch" size="large">
              <span slot="enterButton">
               <img src="../assets/search.png" width="19px"/>
               搜索
              </span>
            </a-input-search>
            <button class="ml20 my-car" @click="goCart">
              <img src="../assets/cart.png" width="23px"/>
              我的购物车
            </button>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <foot-bar></foot-bar>
  </div>
</template>

<script>
import topBar from './sideBar/topBar'
import footBar from './sideBar/footBar'
export default {
  name: 'layout-pay',
  components: {
    topBar,
    footBar
  },
  methods: {
    onSearch () {
      this.$router.push({ path: '/productList/0' })
    },
    goCart () {
      this.$router.push({ path: '/shoppingCart' })
    }
  }
}
</script>
<style lang="less">
.ant-input-search-enter-button .ant-input-group-addon .ant-input-search-button {
  font-size: 14px;
  font-weight: 700;
  background: #F88F6F;
}
</style>
<style lang="less" scoped>
.layout-pay {
  .body {
    box-shadow: 0px 1px 6px #ccc;
  }
  .head {
    padding: 20px 0 5px 0;
    /* width: 1190px;
    margin: 0 auto; */
    .head-top {
      display: flex;
      justify-content: space-between;

      .logo-img {
        cursor: pointer;
      }
      .search-box {
        .search-input {
          height: 41px;
          width: 300px;
          border: 1px solid #ea9476;
          padding-left: 10px;
          outline: none;
        }
        .search-btn {
          display: inline-block;
          line-height: 40px;
          width: 80px;
          text-align: center;
          color: #fff;
          background: #ea9476;
          vertical-align: bottom;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
        }
        .my-car {
          height: 40px;
          border: none;
          color: #fff;
          font-size: 14px;
          font-weight: 700;
          background: #7ccb9b;
          padding: 0 20px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
